export function getLayoutShellWidthClass(pathname: string): string {
  if (
    /^\/apps\/[^/]+\/accounts(?:\/|$)/.test(pathname)
    || /^\/apps\/q-language\/(?:internal-testers|operations|content)(?:\/|$)/.test(pathname)
    || /^\/content(?:\/|$)/.test(pathname)
  ) {
    return 'mx-auto w-full max-w-none px-4 xl:px-6 2xl:px-8';
  }

  return 'container mx-auto max-w-7xl px-4';
}
